import { useMemo } from "react";
import { useSelector } from "react-redux";


const useTodaysBookings = () => {
  const allBookings = useSelector((state) => state.common.bookings);

  return useMemo(() => {
    const now = new Date();
    return allBookings.filter((b) => {
      if (b.bookingStatus === "Canceled") return false;
      const s = new Date(b.start);
      return (
        s.getFullYear() === now.getFullYear() &&
        s.getMonth() === now.getMonth() &&
        s.getDate() === now.getDate()
      );
    });
  }, [allBookings]);
};

export default useTodaysBookings;